import Wrapper from './wrapper';
import { IWrapper } from './types';
import type {
  IMATEntry,
  IMATListParams,
  IMATListResponse,
  MatDiscoveryResponse,
  MatDiscoveryKeysOnlyResponse,
  MatFieldsInfoResponse,
} from '../types/mat-types';
import { ITrainingSet } from '../types/my-types';

class MAT {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  matDiscovery(params?: { page?: number } & Record<string, any>) {
    return this.wrapper.client.get<MatDiscoveryResponse, MatDiscoveryResponse>(
      `data-pools/${this.wrapper.dataPoolId}/mat-discovery/`,
      { params }
    );
  }

  matDiscoveryKeysOnly(params?: Record<string, any>) {
    return this.wrapper.client.get<MatDiscoveryKeysOnlyResponse, MatDiscoveryKeysOnlyResponse>(
      `data-pools/${this.wrapper.dataPoolId}/mat-discovery/keys-only`,
      { params }
    );
  }

  list(orgId: string, params: IMATListParams) {
    return this.wrapper.client.get<IMATListResponse, IMATListResponse>(
      `organizations/${orgId}/mat`,
      { params }
    );
  }

  create(orgId: string, body: any) {
    return this.wrapper.client.post<IMATEntry, IMATEntry>(`organizations/${orgId}/mat`, body);
  }

  update(orgId: string, matId: number, body: any) {
    return this.wrapper.client.patch<IMATEntry, IMATEntry>(
      `organizations/${orgId}/mat/${matId}`,
      body
    );
  }

  retrieve(orgId: string, matId: string) {
    return this.wrapper.client.get<IMATEntry, IMATEntry>(`organizations/${orgId}/mat/${matId}`);
  }

  fieldsInfo(orgId: string) {
    return this.wrapper.client.get<MatFieldsInfoResponse, MatFieldsInfoResponse>(
      `organizations/${orgId}/mat/fields-info`
    );
  }

  exportCsv(orgId: string, params: Record<string, any>) {
    return this.wrapper.client.get<Blob, Blob>(`organizations/${orgId}/mat/export_csv`, {
      params,
      responseType: 'blob' as any,
    });
  }

  templateCsv(orgId: string, params: Record<string, any>) {
    return this.wrapper.client.get<Blob, Blob>(`organizations/${orgId}/mat/template-csv`, {
      params,
      responseType: 'blob' as any,
    });
  }

  importCsv(orgId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.wrapper.client.post<any, any>(`organizations/${orgId}/mat/import_csv`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default MAT;
